export default [
  {
    path: '/payment/credit/back',
    name: 'PaymentCreditBack',
    component: () => import('@/components/payment/credit/back'),
    meta: {
      requiresAuth: true,
      services: []
    }
  },
  {
    path: '/payment/credit/redirect',
    name: 'PaymentCreditRedirect',
    component: () => import('@/components/payment/credit/redirect'),
    meta: {
      requiresAuth: true,
      services: []
    }
  },
  {
    path: '/payment/deposit/redirect',
    name: 'PaymentDepositRedirect',
    component: () => import('@/components/payment/deposit/redirect'),
    meta: {
      requiresAuth: true,
      services: []
    }
  },
  {
    path: '/payment/credit/amend-redirect',
    name: 'AmendPaymentCreditRedirect',
    component: () => import('@/components/payment/credit/AmendRedirect'),
    meta: {
      requiresAuth: false,
      services: []
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/paymentModule.js